(function ($) {
    'use strict';

    $('.off-canvas-menu .has-dropdown').prepend('<span class="toggle-btn"><i class="icon"></i></span>');

    $('.off-canvas-menu .has-dropdown > .toggle-btn').on('click', function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
        $(this).parent().children('.sub-menu').slideToggle();
        $(this).parent().siblings().children('.sub-menu').slideUp();
        $(this).parent().siblings().removeClass('active');
    });

    $(".open-sidebar").on('click', function () {
        $('body').addClass('stop-scroll');
        $('.off-canvas-section').addClass('active');
        $('.off-canvas-wrap').addClass('active');
    });

    $(".off-canvas-overlay").on('click', function () {
        $('body').removeClass('stop-scroll');
        $(this).parent().removeClass('active');
        $('.off-canvas-wrap').removeClass('active');
    });

    $(".off-canvas-close").on('click', function () {
        $('body').removeClass('stop-scroll');
        $('.off-canvas-section').removeClass('active');
        $('.off-canvas-wrap').removeClass('active');
    });


    if (jQuery(".testimonial-slider-active .swiper").length > 0) {
        let testimonialSlider = new Swiper('.testimonial-slider-active .swiper', {
            loopedSlides: 1,
            slidesPerView: 3,
            spaceBetween: 30,
            loop: true,

            // Navigation arrows
            navigation: {
                nextEl: '.testimonial-button-next',
                prevEl: '.testimonial-button-prev',
            },


            autoplay: {
                delay: 3000,
            },

            a11y: false,

            breakpoints: {
                320: {
                    slidesPerView: 1,
                }, 768: {
                    slidesPerView: 2,
                }, 1024: {
                    slidesPerView: 2,
                }, 1200: {
                    slidesPerView: 3,
                },
            },
        });
    }

    if (jQuery(".selling-slider-active .swiper").length > 0) {
        let testimonialSlider = new Swiper('.selling-slider-active .swiper', {
            loopedSlides: 1,
            slidesPerView: 3,
            spaceBetween: 15,
            loop: true,

            // Navigation arrows
            navigation: {
                nextEl: '.selling-button-next',
                prevEl: '.selling-button-prev',
            },


            autoplay: {
                // delay: 3099090,
                delay: 3000,
            },

            a11y: false,

            breakpoints: {
                320: {
                    slidesPerView: 2,
                }, 768: {
                    slidesPerView: 2,
                }, 1024: {
                    slidesPerView: 2,
                }, 1200: {
                    slidesPerView: 3,
                },
            },
        });
    }

    if (jQuery(".blog-slider-active .swiper").length > 0) {
        let testimonialSlider = new Swiper('.blog-slider-active .swiper', {
            loopedSlides: 1,
            slidesPerView: 3,
            spaceBetween: 30,
            loop: true,

            // Navigation arrows
            navigation: {
                nextEl: '.blog-button-next',
                prevEl: '.blog-button-prev',
            },


            autoplay: {
                delay: 3000,
            },

            a11y: false,

            breakpoints: {
                320: {
                    slidesPerView: 1,
                }, 768: {
                    slidesPerView: 2,
                }, 1024: {
                    slidesPerView: 2,
                }, 1200: {
                    slidesPerView: 3,
                },
            },
        });
    }

})(jQuery);
